export default function Footer() {
  return (
    <div className="w-full flex justify-center items-center text-white text-[12px] max-w-layout mx-auto mt-auto bg-primary h-[34px]">
      <span>All Right Reserved Anon Detect</span>
    </div>
  );
}
